import { forwardRef } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

export default forwardRef<HTMLAnchorElement, NavLinkProps>((props, ref) => (
  <NavLink ref={ref} {...props} />
));
